import { render, staticRenderFns } from "./select-lens-cover-video.vue?vue&type=template&id=4c9fa65f&scoped=true&"
import script from "./select-lens-cover-video.vue?vue&type=script&lang=js&"
export * from "./select-lens-cover-video.vue?vue&type=script&lang=js&"
import style0 from "./select-lens-cover-video.vue?vue&type=style&index=0&id=4c9fa65f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fa65f",
  null
  
)

export default component.exports